import { render, staticRenderFns } from "./FootTotals.vue?vue&type=template&id=b6011c92"
import script from "./FootTotals.vue?vue&type=script&lang=js"
export * from "./FootTotals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports